import store from '../store'

function isRole () {
  if (store.state.login && store.state.login.role) {
    return store.state.login.role
  }
  return (store.state.restaurant && store.state.restaurant.role) ? store.state.restaurant.role : null
}

export default function plugin (Vue) {
  if (plugin.installed) {
    return
  }

  plugin.installed = true

  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$is = isRole
}
